// wi_0fc147fe-ef43-46b8-9e3b-5e2c8e90f70c: is a rate built on too few attempts?
// min_sample and sample_key come from GET /coach/stat_definitions. null when the
// stat has no floor or the definitions are not loaded.
// eslint-disable-next-line import-x/prefer-default-export
export function sampleState(statKey, values, definitions) {
  const recipe = definitions?.[statKey];
  if (recipe?.min_sample == null) return null;
  const count = values?.[recipe.sample_key]?.value ?? null;
  const minSample = recipe.min_sample;
  return { count, minSample, belowMin: count == null || count < minSample };
}
